<template>
  <div>
    <sweet-modal
      ref="modal"
      overlay-theme="dark"
      blocking
      enable-mobile-fullscreen
      :width="modalWidth"
      @close="modalClosed"
    >
      <div class="flex flex-col md:flex-row">
        <div
          v-for="category in categorized_tags"
          :key="category.id"
          class="flex flex-col mx-4 sm:mx-2"
        >
          <p class="block uppercase my-8 text-brand font-medium text-lg h-8">
            {{ category.name }}
          </p>
          <button
            v-for="tag in category.tags"
            :key="tag.id"
            type="button"
            class="rounded w-full my-1 border text-sm2 font-medium my-1 py-3 px-2 hover:border-brand text-grey-darker border-grey"
            :class="{ 'bg-brand text-white border-brand': isSelected(tag) }"
            @click="selectTag(tag)"
          >
            {{ tag.name }}
          </button>
        </div>
      </div>
      <div class="mt-8 border-t">
        <button
          type="button"
          class="rounded py-3 px-4 text-white mt-8"
          :class="[
            selectedTags.length == 0
              ? 'bg-grey cursor-not-allowed'
              : 'bg-brand hover:bg-brand-darker',
          ]"
          @click="$refs.confirm.open()"
          :disabled="selectedTags.length == 0"
        >
          Replace Tag
        </button>
      </div>
    </sweet-modal>

    <sweet-modal icon="warning" overlay-theme="dark" ref="confirm">
      <div class="flex flex-col">
        <span>
          This action will replace the Tags for currently selected files, are
          you sure you want to continue?
        </span>

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click="submit"
          >
            Yes
          </button>
          <button
            class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
            @click="$refs.confirm.close()"
          >
            No
          </button>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal ref="loading" overlay-theme="dark" hide-close-button>
      <div class="mt-4">
        <p class="text-6xl text-grey-dark">
          <i class="fa fa-spin fa-circle-notch"></i>
        </p>
        Please wait...
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Sentry from "@sentry/vue";

export default {
  name: "ReplaceTag",

  props: ["files"],

  data() {
    return {
      selectedTags: [],
    };
  },

  methods: {
    async submit() {
      this.$refs.loading.open();

      const tagIds = this.selectedTags.map((t) => t.id);
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        try {
          const res = await axios.patch(
            `/api/vaults/${this.$route.params.vault_id}/files/${file.id}/replace-tags`,
            {
              tags: tagIds,
            }
          );
          const { success } = await res.data;
          if (success) {
            this.$noty.success(`Successfully replace tag for ${file.filename}`);
          }
        } catch (error) {
          Sentry.captureException(error);
          this.$noty.error(`Failed to replace tag for ${file.filename}`);
        }
      }

      this.$refs.loading.close();
      this.$refs.confirm.close();
      this.$refs.modal.close();

      setTimeout(() => {
        this.$emit("replaced");
      }, 500);
    },

    selectTag(tag) {
      if (!this.isSelected(tag)) {
        this.selectedTags.push(tag);
        return;
      }

      this.selectedTags = this.selectedTags.filter((t) => t.id != tag.id);
    },

    isSelected(tag) {
      return this.selectedTags.find((t) => t.id == tag.id);
    },

    modalClosed() {
      this.selectedTags = [];
    },
  },

  computed: {
    ...mapGetters({
      categorized_tags: "getCategorizedTags",
    }),

    modalWidth() {
      return this.$mq == "mobile" ? "100%" : "80%";
    },
  },
};
</script>
